import React from 'react'
import { params } from '../../../../../../redux/reducers/reducer';
import WallNameTemplate from '../../../../WallName/WallNameTemplete';

const WallName = () => {

    let wallTemplates = [
        { position: [(params.p_w / 2 + params.leanR_p_d + 1), 0, 0], rotation: [0, Math.PI / 2, 0], slopeAngle: 60, value: 'Right Building  Front' },
        { position: [(params.p_w / 2 + params.leanR_p_d / 2), 0, params.leanR_p_w / 2 + 1], slopeAngle: 60, rotation: [0, 0, 0], value: 'Right Building Left' },
        { position: [(params.p_w / 2 + params.leanR_p_d / 2), 0, -(params.leanR_p_w / 2 + 1)], rotation: [0, Math.PI, 0], slopeAngle: 60, value: 'Right Building Right' }
    ]
    if(params.add_storage_check_right) {
        if (params.rightLeanStoragePosition !== params.leanR_p_d - parseInt(params.add_storage_right)) {
            let positionZ = (params.p_w / 2  + parseInt(params.add_storage_right) + params.rightLeanStoragePosition)  
            let rightFront =  {
                position: [positionZ, 0, 0], 
                rotation: [0, Math.PI / 2, 0], 
                slopeAngle: 60,
                value:'Right Building Storage Front' 
                };
            wallTemplates =[...wallTemplates,rightFront]
        }
        if (params.rightLeanStoragePosition !== 0) {
            let positionZ = (params.p_w / 2 + params.rightLeanStoragePosition)  
            let rightFront =  {
                position: [positionZ, 0, 0], 
                rotation: [0, -Math.PI / 2, 0], 
                slopeAngle: 60,
                value:'Right Building Storage Back' 
                };
            wallTemplates =[...wallTemplates,rightFront]
        }
    }
    return (
        <>
            {wallTemplates.map((template, index) => (
                <WallNameTemplate
                    key={index}
                    position={template.position}
                    rotation={template.rotation}
                    value={template.value}
                    slopeAngle={template.slopeAngle}
                />
            ))}
        </>
    )
}

export default WallName